import PbAjax from '../../../lib/pbajax';
import url from 'c-url';
import publicpb from '../../../base/public.pb';
import UserSetPwdPb from './usersetpwd.pb';
import {hex_md5} from '../../../base/md5';
import Cache from 'c-cache';
let pbajax = new PbAjax();
let cache = new Cache({
    prefix: 'pcuplive'
});
class UserSetPwd {

    constructor(data = {}) {
        this.promise = this.findPwd(data);
    }

    findPwd(data) {
        
        let self = this;
        let defer = $.Deferred();
        const { Request, Response } = UserSetPwdPb.User.SetPassword;
       
        let businessData = new Request(data);

        let requestData = {
            service: 'service',
            api: '/user/set/password',
            header: {
                userToken: UP.Global.getUserToken(),
                
            }
        }

        pbajax.do(
            requestData,
            businessData,
            function(res) {
                let dataWrap = publicpb.Result.decode(res);
                
                if (dataWrap.code == 1) {
                   
                    defer.resolve(dataWrap);
                    
                } else {
                    defer.reject(dataWrap);
                }
            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            });
        return defer;
    }
}

export default UserSetPwd;



// WEBPACK FOOTER //
// ./js/component/phone-login/findpwd/index.js